import { HomeRounded, SpaceDashboardRounded } from '@mui/icons-material';
import type { NavItemType } from '../types/menu';

const icons = {
  navigation: HomeRounded,
  dashboard: SpaceDashboardRounded,
};

const dashboard: NavItemType = {
  id: 'group-dashboard',
  title: 'Dashboard',
  type: 'group',
  icon: icons.navigation,
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.dashboard,
      navAlwaysAccessible: true,
    },
  ],
};

export default dashboard;
